import { ref, watch } from 'vue'
import axios from 'axios'
import useNotification from '@/composables/useNotification.js'
import { useAuth } from '@/composables/auth/useAuth'
import { useValidation } from '@/composables/utils/useValidation'

const URLS = {
    xhr: {
        fetch: {
            user: '/api/profile/v1/settings/user'
        },
        mutate: {
            login: '/api/login'
        }
    },
    redirect: {
        passwordReset: '/password/reset-by-email'
    }
}

export const useLoginStep = () => {
    const { isValid } = useValidation()
    const { notification } = useNotification()
    const { load, userValues } = useAuth()

    const passwordVisible = ref(false)
    const formValues = ref({
        email: '',
        password: ''
    })
    const serverErrors = ref({
        email: '',
        password: ''
    })

    ;(() => {
        if (userValues.value.email) {
            formValues.value.email = userValues.value.email
        }
    })()

    watch(
        () => formValues.email,
        (email) => {
            if (!email) {
                serverErrors.value.email = ''
            }
        }
    )
    watch(
        () => formValues.password,
        (password) => {
            if (!password) {
                serverErrors.value.password = ''
            }
        }
    )

    function handleRedirectResetPw() {
        window.open(URLS.redirect.passwordReset, '_blank')
    }
    function togglePasswordVisibility() {
        passwordVisible.value = !passwordVisible.value
    }
    async function handleLogin(v) {
        _clearServerErrors()

        if (isValid(v)) {
            try {
                load.value = true

                const response = await axios.post(URLS.xhr.mutate.login, formValues.value)
                const { token, redirect } = response.data

                if (token) {
                    sessionStorage.setItem('auth_token', token)
                }

                if (redirect) {
                    window.location.href = redirect
                }

                return response
            } catch (error) {
                if (error.response) {
                    if (error.response.data.errors) {
                        const { email, password } = error.response.data.errors
                        serverErrors.value.email = email ? email[0] : ''
                        serverErrors.value.password = password ? password[0] : ''
                    }
                    notification('error', 'Authentication failed.')
                } else {
                    notification('error', 'An error occurred while processing your request.')
                }
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Authentication failed.')
        }
    }
    function _clearServerErrors() {
        Object.keys(serverErrors.value).forEach((key) => {
            serverErrors.value[key] = ''
        })
    }

    return {
        URLS,

        load,
        passwordVisible,
        formValues,
        serverErrors,

        handleLogin,
        handleRedirectResetPw,
        togglePasswordVisibility
    }
}
